import { formatDateToApiIso } from "@/src/utils/formatDateToApiIso";
import { formatOfficeAccountingGeneralStatusForApi } from "@/src/constants/officeAccountingTableConfig";

export type OfficeAccountingUpdateTarget = "accounting" | "applicant";

export interface OfficeAccountingColumnUpdateMapping {
  target: OfficeAccountingUpdateTarget;
  apiField: string;
  isDate?: boolean;
}

/** Columns that already have edit popups in Office Accounting table. */
const COLUMN_UPDATE_MAP: Record<string, OfficeAccountingColumnUpdateMapping> = {
  country: { target: "applicant", apiField: "country" },
  dateOfBirth: { target: "applicant", apiField: "birth_date", isDate: true },
  passportIssued: { target: "applicant", apiField: "passport_issued", isDate: true },
  validPassport: { target: "applicant", apiField: "valid_passport", isDate: true },
  phone: { target: "applicant", apiField: "phone" },
  email: { target: "applicant", apiField: "email" },

  managersEmail: { target: "accounting", apiField: "managers_email" },
  agentsEmail: { target: "accounting", apiField: "agents_email" },
  currentSemester: { target: "accounting", apiField: "current_semester" },
  generalStatus: { target: "accounting", apiField: "general_status" },
  invoiceNumber: { target: "accounting", apiField: "invoice_number" },
  statusAdmissionPayment: { target: "accounting", apiField: "status_admission_payment" },
  statusAl: { target: "accounting", apiField: "status_al" },
  statusEmail: { target: "accounting", apiField: "status_email" },
  statusEdbo: { target: "accounting", apiField: "status_edbo" },
  statusInvitationFee: { target: "accounting", apiField: "status_invitation_fee" },
  balanceStatusUsd: { target: "accounting", apiField: "balance_status_usd" },
  statusMissedClasses: { target: "accounting", apiField: "status_missed_classes" },
};

export const mapOfficeAccountingColumnUpdate = (columnId: string): OfficeAccountingColumnUpdateMapping | null =>
  COLUMN_UPDATE_MAP[columnId] ?? null;

export const formatOfficeAccountingUpdateValue = (
  mapping: OfficeAccountingColumnUpdateMapping,
  value: string,
): string => {
  if (mapping.apiField === "general_status") {
    return formatOfficeAccountingGeneralStatusForApi(value);
  }
  return mapping.isDate ? formatDateToApiIso(value) || value.trim() : value;
};
